/** TimesheetInput modification status */
export enum TimesheetInputModification {
  /** modification status create */
  CREATE  = "create",
  /** modification status update */
  UPDATE = "update",
  /** modification status delete */
  DELETE = "delete"
}